// src/store/thunks/sixCatalog/setSearchAndFetchThunk.ts

import { setSearch } from '@/store/slices/sixCatalog/sixCatalogSlice';
import { fetchSixCatalogThunk } from '@/store/thunks/sixCatalog/fetchSixCatalog';
import { createAppAsyncThunk } from '@/store/thunks/createAppAsyncThunk';

/**
 * Sets the search term and fetches the updated catalog.
 * This thunk first updates the search in state, then dispatches
 * fetchSixCatalog with the current filters and new search term.
 */
export const setSearchAndFetchThunk = createAppAsyncThunk<undefined, string | undefined>(
  'catalog/setSearchAndFetch',
  async(searchTerm, { dispatch, getState }) => {
    // Set the search in state
    dispatch(setSearch(searchTerm));

    // Get current filters and sort from state
    const state = getState();
    const { filters, sortField, sortDirection } = state.sixCatalog;

    // Fetch catalog with updated search
    await dispatch(
      fetchSixCatalogThunk({
        filters,
        search: searchTerm,
        sortField,
        sortDirection,
      })
    );
    return undefined;
  }
);
